/* Trustpilot TrustBox — theme editor re-initialisation.

   Trustpilot's bootstrap (loaded in layout/theme.liquid) scans the DOM once, on
   load, and initialises every .trustpilot-widget it finds. In the theme editor a
   section is re-rendered on edit, which produces a fresh, un-scanned container —
   the widget would render as an empty gap and look broken to the merchant.

   Re-scanning only the reloaded section keeps the editor honest without touching
   widgets elsewhere on the page. Storefront visitors never run this path. */

if (!customElements.get("trustpilot-widget")) {
  customElements.define(
    "trustpilot-widget",
    class TrustpilotWidget extends HTMLElement {
      connectedCallback() {
        // The bootstrap is async, so it may not have arrived yet on first paint.
        // It initialises this widget itself when it does; we only need to act
        // when it is already present (i.e. a later re-render).
        this.load();
      }

      load() {
        const box = this.querySelector(".trustpilot-widget");
        if (box && window.Trustpilot) {
          window.Trustpilot.loadFromElement(box, true);
        }
      }
    },
  );
}

document.addEventListener("shopify:section:load", (event) => {
  event.target.querySelectorAll("trustpilot-widget").forEach((el) => el.load?.());
});
